import { api } from "@/utils/api";
import { SpecificationSchema, SpecificationSchemaCreate, SpecificationSchemaUpdate } from "@/types/productAttributes";

export const productAttributesApi = {
  getAll: async () => {
    const response = await api.get<SpecificationSchema[]>("/api/specification-schemas/");
    return response.data;
  },

  getById: async (id: string) => {
    const response = await api.get<SpecificationSchema>(`/api/specification-schemas/${id}/`);
    return response.data;
  },

  create: async (data: SpecificationSchemaCreate) => {
    const response = await api.post<SpecificationSchema>("/api/specification-schemas/", data);
    return response.data;
  },

  update: async (id: string, data: SpecificationSchemaUpdate) => {
    const response = await api.put<SpecificationSchema>(`/api/specification-schemas/${id}/`, data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/api/specification-schemas/${id}/`);
    return response.data;
  },
};